module.exports = "/_next/static/images/Raj_Tank-06dbbccdeae88c7347005dd9776dfabc.webp";